<div class="page-container">
    <div class="header-container" >
        <div class="wrapper">
          <div class="header">
            Audits
          </div>
    
          <app-button customClasses="px-4"
                      text="Create Audit"
                      (clicked)="openCreateAuditModal()"
          ></app-button>
        </div>
      </div>

      <div class="table-controls" [formGroup]="filterAuditsForm">
        <app-search-input class="search-control"
            [color]="SearchInputColorEnum.Green"
            [hideDropdown]="true"
            placeholder="Search by drug name or NDC"
            [loading]="loading$ | async"
            formControlName="searchValue"
        ></app-search-input>

        <app-multiselect-dropdown
          class="filter"
          formControlName="auditTypes"
          [placeholder]="'All Types'"
          [data]="auditTypesWithBackCountList"
          [dropdownListPaddingTop]="0"
        ></app-multiselect-dropdown>
      </div>

      <div class="table-scroll-wrapper" *ngIf="(audits$ | async)?.length; else emptyTable">
        <table class="table-primary audits-table">
            <thead>
            <tr>
              <th (click)="sortColumn('createDate')" class="text-left sort date" scope="col">
                Audit Date
                 <img [class.asc]="tableColumns.createDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
                </th>
              <th (click)="sortColumn('type')" class="text-left sort type" scope="col">
                Audit Type
                <img [class.asc]="tableColumns.type" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
              </th>
              <th class="text-left sort type" scope="col">
                Locations
              </th>
              <th (click)="sortColumn('lineItemsCount')" class="text-right sort line-items" scope="col">
                NDCs
                <img [class.asc]="tableColumns.lineItemsCount" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
              </th>
              <th (click)="sortColumn('status')" class="text-left sort status" scope="col">
                Status
                <img [class.asc]="tableColumns.status" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
              </th>
              <th (click)="sortColumn('completeDate')" class="text-left sort date" scope="col">
                Complete Date
                <img [class.asc]="tableColumns.completeDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
                     alt="asc"/>
              </th>
              <th class="text-right controls" scope="col">
             
              </th>
            </tr>
            </thead>
            <tbody>
            <tr class="table-row" *ngFor="let rowData of audits$ | async; let i = index">
              <td class="text-left date">
                {{rowData.createDate | formattedDate: 'MM d a, HH:mm'}}
              </td>
              <td class="text-left type">
                <div class="heading">
                  <span *ngIf="rowData.type === AuditTypesEnum.AdHoc">
                      Ad Hoc
                  </span>
                  <span *ngIf="rowData.type === AuditTypesEnum.AllDrugs">
                      All Drugs
                  </span>
                  <span *ngIf="rowData.type === AuditTypesEnum.ActiveDrugs">
                      Active Drugs
                  </span>
                  <span *ngIf="rowData.type === AuditTypesEnum.InactiveDrugs">
                      Inactive Drugs
                  </span>
                  <span *ngIf="rowData.type === AuditTypesEnum.NinetyDayAudit">
                      90 Day Audit Report
                  </span>
                  <span *ngIf="rowData.type === AuditTypesEnum.BackCount">
                    Back Count
                  </span>
                  <span *ngIf="rowData.type === AuditTypesEnum.TotalsOnly">
                    Totals Only Audit
                  </span>
                </div>
                <div class="secondary">
                  {{getDateRange(rowData?.from, rowData?.to)}}
                </div>
              </td>
              <td class="text-left type">
                {{rowData.actualInventoryLocationIDs | locationsList}}
              </td>
              <td class="text-right line-items"> 
                <div>
                  {{rowData.lineItemsCount}}
                </div>
                <div class="secondary !text-right" *ngIf="c3c5Enabled">
                  {{rowData?.actualSchedules | schedulesList}}
                </div>
              </td>
              <td class="text-left status">
                <app-badge *ngIf="rowData.status === AuditStatusesEnum.Pending" [color]="BadgeColorsEnum.Yellow">
                    Pending
                </app-badge>
                <app-badge *ngIf="rowData.status === AuditStatusesEnum.InProgress" [color]="BadgeColorsEnum.Blue">
                    In Progress
                </app-badge>
                <app-badge *ngIf="rowData.status === AuditStatusesEnum.Completed" [color]="BadgeColorsEnum.Green">
                    Complete
                </app-badge>
              </td>
              <td class="text-left date">
                {{rowData.completeDate | formattedDate: 'MM d a, HH:mm'}}
              </td>
              <td class="text-right controls">
                <div class="delete-icon delete-btn" *ngIf="rowData?.containsNoneOrAllUnconfirmedNDCs && rowData.type !== AuditTypesEnum.BackCount"
                  (click)="dropAudit(rowData.id)">
                </div>
                <span class="details" (click)="goToDetails(rowData.id)">Details</span>
              </td>
            </tr>
            </tbody>
          </table>
      </div>
</div>

<app-dialog *ngIf="displayCreateAuditTypeSelector"
  [show]="true"
  [showHeader]="true"
  [header]="'Create Audit'"
  saveBtnText="Create"
  [minWidth]="530"
  [hasControls]="true"
  (save)="createAuditWithSelectedType()"
  (cancel)="cancelAuditCreation()"
  >

  <div class="select-type" [formGroup]="createAuditForm">
    <app-dropdown label="Select type"
                  (chosenOption)="auditTypeSelected($event)"
                  [options]="auditTypesList"
                  [isOptionObject]="true"
                  [isLoading]="loading$ | async"
                  [placeholder]="'Select'"
                  formControlName="type"
                  #auditTypesDropdown
      ></app-dropdown>

      <app-input *ngIf="selectedAuditType === AuditTypesEnum.TotalsOnly"
        formControlName="name"
        label="Audit Title"
        placeholder="Enter Audit Title"
        class="block mt-4"
      > 
      </app-input>
      <div>
        <app-schedules-filter *ngIf="c3c5Enabled && selectedAuditType > AuditTypesEnum.AdHoc"
          class="schedule"
          label="Schedule"
          [control]="schedules">
        </app-schedules-filter>
      </div>
      <div class="period-picker-container" *ngIf="displayTimePeriodDropdown">
        <app-dropdown 
                      [label]="'Time Period'"
                      [placeholder]="'All Time'"
                      (chosenOption)="changePeriod($event)"
                      [isOptionObject]="true"
                      [options]="periodsList"
                      [isLoading]="loading$ | async"
                      (tabEnterEvent)="focusMultioptionalDropdown('usersMultioptionalDropdown')"
                      #periodDropdown
        ></app-dropdown>
         <app-datepicker-input 
                  [tabInd]="0"
                  [selectMode]="'range'"
                  (dateTimeChange)="customPeriodChanged($event)"    
                  [dateMax]="todayDate"
                  #customPeriodDatepicker
          ></app-datepicker-input> 
      </div>

      <div [formGroup]="ninetyDayAuditTimeForm" *ngIf="display90DayAuditOptions" class="additional-options-container">
        <div class="additional-options">
          <div class="period-picker-container">
            <app-dropdown 
              [label]="'Start Date'"
              (chosenOption)="changePeriod($event)"
              [isOptionObject]="true"
              [options]="periodsListFor90DayAudit"
              [isLoading]="loading$ | async"
              (tabEnterEvent)="focusMultioptionalDropdown('usersMultioptionalDropdown')"
              #periodDropdown
            ></app-dropdown>
            <app-datepicker-input
              [tabInd]="0"
              (dateTimeChange)="startDateChanged($event)"
              [dateMax]="todayDate"
              [dateMin]="nDaysPriorToday"
              #customPeriodDatepicker
            ></app-datepicker-input> 
          </div>
          <div class="time-of-inventory">
            <app-options-list
              [bordered]="false"
              [optionsList]="auditTimeList"
              [disableWithIds]="startDateDisabledTimeTypes"
              formControlName="startDateType"
            ></app-options-list>
          </div>
        </div>
        <div class="additional-options">
          <app-input
            [initialValue]="todayDate | formattedDate: 'MM/dd/yyyy'"
            customClasses="!pr-8"
            label="End Date"
            [readOnly]="true"
            [disable]="true"
            class="pt-[24px]"
          ></app-input>
          <div class="time-of-inventory">
            <app-options-list
              [bordered]="false"
              [optionsList]="auditTimeList"
              [disableWithIds]="endDateDisabledTimeTypes"
              formControlName="endDateType"
            ></app-options-list>
          </div>
        </div>
      </div>
      <div class="block mt-4">
        <app-inventory-locations-filter
          label="Location"
          [control]="inventoryLocations">
        </app-inventory-locations-filter>
      </div>
    <app-error-message *ngIf="displayNoDrugsError$ | async" class="font-medium">
      <span *ngIf="selectedAuditType === AuditTypesEnum.AllDrugs">There are no drugs in inventory.  <br>  
        You can <a href="/inventory/bulk-add" class="underline underline-offset-1">add drugs here</a>.</span>
      <span *ngIf="selectedAuditType !== AuditTypesEnum.AllDrugs">There are no drugs.  <br>  Try selecting a different time period or location.</span>
    </app-error-message>
</div>
</app-dialog>

<ng-template #emptyTable>
  <app-empty-table *ngIf="(loading$ | async) !== true"
                       [labelValue]="'You do not have any audits yet'"
                       icon="audits-empty"
  ></app-empty-table>
</ng-template>

<app-dialog
  *ngIf="pendingDeleteAuditModal$ | async; let pendingDeleteAuditModal"
  [showHeader]="true"
  header="Are you sure you want to delete?"
  subHeader="This action is irreversible.  Proceed?"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex justify-between">
        <app-button customClasses="px-4" text="Cancel" [minWidth]="0" subStyle="transparent" class="cancel-btn"
        (clicked)="pendingDeleteAuditModal$.next(null)" >
        </app-button>
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn" (clicked)="deletingConfirmed(pendingDeleteAuditModal.id)"  [minWidth]="50">
        </app-button>
    </div>
</app-dialog>
